import React from 'react';
import styled from 'styled-components';
/**
 * * 검색 인풋, 등록 버튼 보이는 container
 */

interface IProps {
  children: JSX.Element[] | JSX.Element;
  style?: React.CSSProperties;
}

const TableToolbar = ({ children, style }: IProps) => {
  return <Container style={style}>{children}</Container>;
};
export default TableToolbar;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  /* padding: 1rem 1.2rem; */
  /* background-color: rgba(65, 30, 30, 0.6); */
  /* border-radius: 0.5rem; */

  > div {
    display: flex;

    /* border: solid 2px blue; */
  }
  .mail_search_button_wrap {
    width: 42rem;
    height: 8.2rem;
    position: relative;
    div {
      position: absolute;
      bottom: 0rem;
      right: 0;
    }
  }
  .ant-form-item {
    margin-bottom: 0;
    display: flex;
    /* align-items: center; */
  }
  .ant-form-item-control-input {
    height: 100%;
  }
  .ant-form-item-control-input-content {
    height: 100%;
  }
  input {
    /*  placeholder 꾸미기 */
    ::placeholder,
    ::-webkit-input-placeholder {
      margin-bottom: 5px;
      color: #bdbdbd;
    }
    padding: 0.7rem 0.8rem;
  }
  .ant-input-affix-wrapper {
    width: 25rem;
  }
`;
